module.exports = __webpack_public_path__ + "static/img/235_TO8_1989_og.520f8e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/235_TO8_1989_og.jpg
// module id = Rf3K
// module chunks = 0